// @flow
import { START_LOADING, END_LOADING } from 'Store/global-loader/globalLoader.action';

type State = boolean;

const initialState: State = false;

export const isNavigation = (state?: State = initialState, action: ?Action<*>): State => {
  switch (action?.type) {
    case START_LOADING:
      return !!action?.payload?.isNavigation;

    case END_LOADING:
      return initialState;

    default:
      return state;
  }
};
